import React from 'react'

const NotFound = () => {
  return (
    <div id='upgradeableContracts' style={{ textAlign: 'center' }}>
      <h1 style={{ marginTop: '25%' }}>404 - Not Found</h1>
    </div>
  )
}

export default NotFound
